import { useState } from "react";
import { IQuestion } from "./IQuestion";
import s from './Question.module.css'
import cn from 'classnames'
import Image from 'next/image'

const Question: IQuestion = ({ question, answer }) => {
    const [isOpened, setIsOpened] = useState(false);


    const handleClick = () => {
        setIsOpened(!isOpened);
    }

    return <div 
    key = {`question_${question}`}
    className = {cn(s.container)}
    >
        <div
            className={cn(s.question)}
            onClick={handleClick}
        >
            <span>
                {question}
            </span>
            <div className = {cn(s.chevron)}>
                <Image
                    src="/assets/FAQ/chevron.png"
                    width={21}
                    height="13"
                    layout="intrinsic"
                />
            </div>
        </div>
        <div
            className={cn(
                { [s.opened]: isOpened },
                s.answer
            )}
        >
            {
                answer
            }
        </div>
    </div>
}

export default Question;